
import React, { useState, useContext } from 'react'
import Textarea from 'components/Textarea'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import BoldComment from 'assets/icons/bold-comment'
import HighlightComment from 'assets/icons/highlight-comment'
import AssigmentComment from 'assets/icons/assigment-comment'
import LeaveComment from 'assets/icons/leave-comment'
import { requestAddReplyData } from 'api/site'
import { SiteContext } from 'providers/site'
import { useParams } from 'react-router-dom'

import {
  CommentArea,
  CommentButtonsLeft,
  CommentButtonsRight,
  LeaveCommentBg,
  TextAreaControls
} from './style'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'
import { editOnly } from 'routing/constants'

const ReplyForm = ({ commentId, getReplyData, replyText, setReplyState, getCommentsData }) => {
  const params = useParams()
  const { site } = useContext(SiteContext)
  const [commentsTextArea, setCommentsTextArea] = useState('')
  const [height, setHeight] = useState('150px')
  const [isExpanded, setIsExpanded] = useState(true)

  const editOnlySite = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID ? editOnly : null;

  const onCommentsChange = (e) => {
    setCommentsTextArea(e.target.value)
  }

  const handleExpandChange = () => {
    setIsExpanded(true)
    setHeight('150px')
  }

  const handleCancelExpandChange = () => {
    setCommentsTextArea('')
    setIsExpanded(false)
    setHeight('25px')
    setReplyState('hide')
  }

  const submitReply = async () => {
    const replyData = {
      content: commentsTextArea
    };

    try {
      await requestAddReplyData(site.id, commentId, params.siteHistoryId, replyData, editOnlySite);
      await getReplyData();
      await getCommentsData();
      setCommentsTextArea('');
      setReplyState('show');
    } catch (error) {
      console.error('Error submitting reply:', error);
    }
  };

  return (
    <div style={{ paddingLeft: '25px' }}>
      <CommentArea>
        <Textarea
          value={commentsTextArea}
          field='commentsTextArea'
          onChange={onCommentsChange}
          onClick={handleExpandChange}
          placeholder="commentsPlaceholder"
          height={height}
          dataTest='comments-text-area'
          resize="none"
          border="none"
          boxShadow="none"
          marginBottom={isExpanded ? '' : '0'}
          description={replyText}
        />
        {isExpanded && <TextAreaControls>
          <CommentButtonsLeft>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <BoldComment />
            </Button>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <HighlightComment />
            </Button>
            <Button marginTop="0" type="leftCommentButtons" onClick={() => {}}>
              <AssigmentComment />
            </Button>
          </CommentButtonsLeft>
          <CommentButtonsRight>
            <Button marginTop="0" type="cancelComments" onClick={handleCancelExpandChange}>
              <FormattedMessage id="cancel" />
            </Button>
            <div style={{ alignSelf: 'center' }} onClick={submitReply}>
              <LeaveCommentBg>
                <LeaveComment />
              </LeaveCommentBg>
            </div>
          </CommentButtonsRight>
        </TextAreaControls>}
      </CommentArea>
    </div>
  )
}

export default ReplyForm
